// Toast definitions
export const toastThemeError = {
    theme: {
        '--toastBackground': 'rgba(128, 0, 0, 0.85)',
        '--toastColor': 'whitesmoke',
        '--toastBarBackground': 'transparent',
        '--toastWidth': '20em'
    },
    duration: 2000,
    initial: 1,
    next: 0,
    dismissable: false
};
export const toastThemeErrorDismissable = {
    theme: {
        '--toastBackground': 'rgba(128, 0, 0, 0.85)',
        '--toastColor': 'whitesmoke',
        '--toastBarBackground': 'transparent',
        '--toastWidth': '20em'
    },
    initial: 0,
    next: 0,
    dismissable: true
};
export const toastThemeWarning = {
    theme: {
        '--toastBackground': 'rgba(128, 128, 0, 0.85)',
        '--toastColor': 'whitesmoke',
        '--toastBarBackground': 'transparent',
        '--toastWidth': '20em'
    },
    duration: 4000,
    initial: 1,
    next: 0,
    dismissable: false
};
export const toastThemeSuccess = {
    theme: {
        '--toastBackground': 'rgba(0, 128, 0, 0.85)',
        '--toastColor': 'whitesmoke',
        '--toastBarBackground': 'transparent',
        '--toastWidth': '20em'
    },
    duration: 2000,
    initial: 1,
    next: 0,
    dismissable: false
};
export const toastThemeSuccessDismissable = {
    theme: {
        '--toastBackground': 'rgba(0, 128, 0, 0.85)',
        '--toastColor': 'whitesmoke',
        '--toastBarBackground': 'transparent',
        '--toastWidth': '20em'
    },
    initial: 0,
    next: 0,
    dismissable: true
};
export const toastThemeInfo = {
    theme: {
        '--toastBackground': 'rgba(0, 128, 0, 0.85)',
        '--toastColor': 'whitesmoke',
        '--toastBarBackground': 'transparent',
        '--toastWidth': '20em'
    },
    initial: 0,
    next: 0,
    dismissable: true
};
